import {AxiosInstance} from 'axios';
import {Provider} from 'react-redux';
import React, {Component} from 'react';
import {Router} from 'react-router-dom';
import {createBrowserHistory} from 'history';

import Routes from '../../routes';
import configureStore from '../../store';
import {configureApi} from '../../api/index';

export let store = configureStore();
export let history = createBrowserHistory();
export let api: AxiosInstance = configureApi(store);

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <Router history={history}>
                    <Routes/>
                </Router>
            </Provider>
        )
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/Base/App.js